import { useEffect, useState, useRef } from 'react';
import "./Contact.css";
import * as THREE from 'three';
import Footer from './Footer';


const Contact = ({ lang }) => {
    let sizes, canvas, scene, camera, light, renderer, box;

    // 오버스크롤, 리사이즈 이벤트 등록 (Three.js 코드와 무관)
    useEffect(() => {
        console.log("Contact use effect");
        let startY = 0;
        let moveY = 0;

        const handleOverScroll = (event) => {
            const scrollTop = window.scrollY;
            if (scrollTop > 0) return;

            if (event.type === "touchstart") {
                startY = event.touches[0].clientY;
            } else if (event.type === "touchmove") {
                moveY = event.touches[0].clientY;
                if (moveY > startY) {
                    window.dispatchEvent(new CustomEvent("closeSubToMain"));
                }
            } else if (event.type === "wheel") {
                if (event.deltaY < 0) {
                    window.dispatchEvent(new CustomEvent("closeSubToMain"));
                }
            }
        };

        // window.addEventListener("touchstart", handleOverScroll);
        // window.addEventListener("touchmove", handleOverScroll);
        // window.addEventListener("wheel", handleOverScroll);
        return () => {
            console.log("Contact use effect return")
            // window.removeEventListener("touchstart", handleOverScroll);
            // window.removeEventListener("touchmove", handleOverScroll);
            // window.removeEventListener("wheel", handleOverScroll);
        }
    }, []);

    // --- Three.js 초기화 관련 코드 (현재 주석 처리됨) ---
    // 아래 코드를 주석 해제하여 사용할 경우, 
    // 애니메이션 루프 취소, 이벤트 리스너 제거 및 Three.js 객체의 dispose 처리를 통해
    // 메모리 누수를 방지할 수 있습니다.
    /*
    useEffect(() => {
      const sizes = {
        width: window.innerWidth,
        height: window.innerHeight
      };
  
      const canvas = canvasRef.current;
      if (!canvas) return;
  
      // Scene, Camera, Light 생성
      const scene = new THREE.Scene();
  
      const camera = new THREE.PerspectiveCamera(
        75,
        sizes.width / sizes.height,
        0.1,
        1000
      );
      camera.position.set(0, 0, 2);
      scene.add(camera);
  
      const light = new THREE.DirectionalLight(0x00dd8f, 0.5);
      light.position.set(0, 2, 3);
      light.castShadow = true;
      light.shadow.mapSize.width = 2048;
      light.shadow.mapSize.height = 2048;
      light.shadow.camera.left = light.shadow.camera.bottom = -15;
      light.shadow.camera.right = light.shadow.camera.top = 15;
      scene.add(light);
  
      // 모델 생성
      const boxGeometry = new THREE.BoxGeometry(1, 1, 1);
      const boxMaterial = new THREE.MeshStandardMaterial({ color: 0xffffff });
      const box = new THREE.Mesh(boxGeometry, boxMaterial);
      box.position.set(1, 0, 0);
      scene.add(box);
  
      // Renderer 생성
      const renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true });
      renderer.setSize(sizes.width, sizes.height);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      renderer.setClearColor(0xffffff, 0);
      renderer.shadowMap.enabled = true;
  
      const renderScene = () => {
        renderer.render(scene, camera);
      };
  
      const animate = () => {
        animationFrameIdRef.current = requestAnimationFrame(animate);
        renderScene();
      };
      animate();
  
      // 윈도우 리사이즈 이벤트 핸들러
      const ResizeScreen = () => {
        sizes.width = window.innerWidth;
        sizes.height = window.innerHeight;
        camera.aspect = sizes.width / sizes.height;
        camera.updateProjectionMatrix();
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        renderer.setSize(sizes.width, sizes.height);
      };
  
      // 마우스 무브에 따른 박스 회전 효과
      const MouseMove = (e) => {
        const mouseX = (e.clientX / window.innerWidth) * 2 - 1;
        const mouseY = (e.clientY / window.innerHeight) * 2 + 1;
        box.rotation.y = mouseX * Math.PI;
        box.rotation.x = mouseY * Math.PI;
      };
  
      window.addEventListener('resize', ResizeScreen);
      window.addEventListener('mousemove', MouseMove);
  
      return () => {
        if (animationFrameIdRef.current) {
          cancelAnimationFrame(animationFrameIdRef.current);
        }
        window.removeEventListener('resize', ResizeScreen);
        window.removeEventListener('mousemove', MouseMove);
        boxGeometry.dispose();
        boxMaterial.dispose();
        renderer.dispose();
      };
    }, []);
    */
    // --- 끝 ---

    const handleButtonClick = (url) => {
        window.open(url, "_blank");
    };

    return (
        <div id="contact" className="contact-container">
            <div className="contact-gradient-1"></div>
            <div className="contact-gradient-2"></div>
            <Footer
                lang={lang}
                isContactPage={true} />
            {/* <div className="contact-info-container">
                <div className="contact-info">
                    <a className="contact-info-item" href="https://naver.me/xKQolpLy" target="_blank" rel="noopener noreferrer" title="Open Map">
                        <p>10F, Halla Eco Valley, 25, Ttukseom-ro 1-gil
                            <br />
                            Seongdong-gu, Seoul 04778, Korea
                        </p>
                    </a>
                    <p className="contact-info-item">
                        <a href="mailto:hello@h9works.com" title="Email to hello@h9works.com" className="contact-info-email-link">hello@h9works.com</a>
                    </p>
                    <div className="contact-info-item">
                        <div className="contact-label">
                            <span className="contact-info-label">Tel</span>
                            <span className="contact-info-label">Fax</span>
                        </div>
                        <div className="contact-number">
                            <span className="contact-info-number">02-521-0518</span>
                            <br />
                            <span className="contact-info-number">02-567-0518</span>
                        </div>
                    </div>
                </div>
                <div className="contact-buttons">
                    <button className="contact-button"
                        onClick={() => {
                            handleButtonClick('https://behance.net/hnine')
                        }}>
                        BEHANCE
                    </button>
                    <button className="contact-button"
                        onClick={() => {
                            handleButtonClick('https://hnine.notion.site/HNINE-e3c952b5ac6943c1bd54c33e1ef73e4a')
                        }}>
                        NOTION
                    </button>
                    <button className="contact-button"
                        onClick={() => {
                            handleButtonClick('https://vimeo.com/hnine')
                        }}>
                        VIMEO
                    </button>
                </div>
            </div>
            <div className="contact_webgl">
                <canvas className="contact_webgl_canvas"></canvas>
            </div> */}
        </div>
    );
};

export default Contact;